// ==== Version 2 — Every unconfirmed admin state resolves to access denied
import React, { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { useAuth } from "../context/AuthContext";
import { needsEmailVerification } from "./emailVerification";
import AccessDenied from "../pages/AccessDenied";

export default function AdminGate({ children }) {
  const { currentUser, loading: authLoading } = useAuth();
  const uid = currentUser?.uid;
  const localMock = currentUser?.bwakLocalMock;
  const localAdmin = currentUser?.bwakLocalMockAdmin;
  const [state, setState] = useState({ uid: null, loading: true, isAdmin: false });

  useEffect(() => {
    let active = true;
    setState({ uid, loading: true, isAdmin: false });
    if (!uid || localMock) {
      setState({ uid, loading: false, isAdmin: !!uid && localMock === true && localAdmin === true });
      return;
    }
    const unsubscribe = onSnapshot(doc(db, "users", uid), (snapshot) => {
      if (active) setState({ uid, loading: false, isAdmin: snapshot.exists() && snapshot.data()?.roles?.admin === true });
    }, () => {
      if (active) setState({ uid, loading: false, isAdmin: false });
    });
    return () => { active = false; unsubscribe(); };
  }, [uid, localMock, localAdmin]);

  if (authLoading) return <Pending>Checking sign-in…</Pending>;
  if (!currentUser) return <AccessDenied />;
  if (needsEmailVerification(currentUser)) return <AccessDenied />;
  if (state.uid !== uid || state.loading) return <Pending>Checking admin access…</Pending>;
  if (!state.isAdmin) return <AccessDenied />;
  return children;
}

function Pending({ children }) {
  return <div role="status" style={{ minHeight: "40vh", display: "grid", placeItems: "center", color: "#FDFCF9", background: "#0A1A33" }}>{children}</div>;
}
